import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const bankOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "开户名",
            prop: "openingName",
            type: "input",
            formsolt: true,
        },
        {
            label: "银行预留电话",
            prop: "mobile",
            type: "input",
            formsolt: true,
        },
        {
            label: "银行名称",
            prop: "name",
            type: "select",
            formsolt: true,
        },
        {
            label: "卡号",
            prop: "number",
            type: "input",
            formsolt: true,
        },
        {
            label: "开户行",
            prop: "openingBank",
            type: "input",
            formsolt: true,
        }
    ]
};